import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation

// Importing images
import verified from "../Assets/TrustCard/verified.png";
import location from "../Assets/TrustCard/location.png";
import Job from "../Assets/TrustCard/Job.png";
import HrCall from "../Assets/TrustCard/HrCall.png";
import Shield from "../Assets/TrustCard/Shield.png";

const TrustCard = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleRegisterClick = () => {
    window.scrollTo(0, 0);
    // Navigate to the HomeRegister page when the button is clicked
    navigate("/HomeRegister"); // Make sure the route is correct
  };

  return (
    
    <div className="bg-background py-10 flex flex-col items-center border-4 border-background mt-2">
      {/* Section with Shield Image and Header */}
      <div className="w-full max-w-6xl mx-auto flex items-center justify-start mb-6 ml-4">
        {/* Shield with Circle Background */}
        <div className="flex justify-center items-center w-24 h-24 bg-logos shadow-[inset_4px_4px_10px_rgba(0,0,0,0.7)] rounded-full mr-4">
          <img src={Shield} alt="Trust Shield" className="w-14 h-14" />
        </div>

        {/* Trust Text */}
        <div>
          <h3 className="text-xl font-bold text-left text-textWhite font-josefin">
            More than 25K+ Indians <br />
            <span className="font-normal">trust JobGenne</span>
          </h3>
        </div>
      </div>

      {/* Main Container with Border (Updated to Blue) */}
      <div className="w-full max-w-6xl mx-auto bg-boxes shadow-lg rounded-lg p-6 border-4 border-boxes border-grey-300">
        {/* Top Section */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h3 className="text-lg font-bold font-josefin text-textWhite">
              Explore Opportunities with <br />
              <span className="font-normal">JobGenne</span>
            </h3>
          </div>
          <button
            onClick={handleRegisterClick} // Click event to navigate to HomeRegister
            className="bg-logos text-textWhite font-semibold px-4 py-2 rounded-md hover:bg-emerald-700 drop-shadow-2xl"
          >
            Register Now
          </button>
        </div>

        {/* Grid Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Box 1 */}
          <div className="flex items-center bg-gray-50 p-6 rounded-lg shadow-lg ">
            <img
              src={verified}
              alt="Free & Genuine Logo"
              className="w-16 h-16"
            />
            <p className="ml-4 text-sm  font-josefin font-medium">
              Free, Genuine Job Opportunities
            </p>
          </div>

          {/* Box 2 */}
          <div className="flex items-center bg-gray-50 p-6 rounded-lg shadow-lg">
            <img src={location} alt="Prime Jobs Logo" className="w-16 h-16" />
            <p className="ml-4 text-sm font-josefin font-medium">Prime Jobs Near You</p>
          </div>

          {/* Box 3 */}
          <div className="flex items-center bg-gray-50 p-6 rounded-lg shadow-lg">
            <img src={Job} alt="Ideal Job Logo" className="w-16 h-16" />
            <p className="ml-4 text-sm font-medium font-josefin">
              Ideal Job Match for Your Skills
            </p>
          </div>

          {/* Box 4 */}
          <div className="flex items-center bg-gray-50 p-6 rounded-lg shadow-lg">
            <img
              src={HrCall}
              alt="Direct HR Interviews Logo"
              className="w-16 h-16"
            />
            <p className="ml-4 text-sm font-medium font-josefin">Direct HR Interviews</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustCard;
